<template>
    <div class="app-inner">
        <div class="searchTitleDiv">
            <div class="stateDiv">
                <p class="searchText">联系人&nbsp;&nbsp;&nbsp;</p>
                <el-input v-model="searchFrom.chineseName" placeholder="请输入" clearable class="inputDiv"></el-input>
            </div>
            <div class="stateDiv">
                <p class="searchText">性别&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <el-select v-model="searchFrom.sex" placeholder="请选择" class="inputDiv" clearable>
                    <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="stateDiv">
                <p class="searchText">婚姻状况</p>
                <el-select v-model="searchFrom.marriageType" placeholder="请选择" class="inputDiv" clearable>
                    <el-option v-for="item in marriageOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="stateDiv">
                <p class="searchText">人才类型</p>
                <el-select v-model="searchFrom.type" placeholder="请选择" class="inputDiv" clearable>
                    <el-option v-for="item in talentOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="searchTitleDiv">
            <div class="stateDiv">
                <p class="searchText">当前岗位</p>
                <el-input v-model="searchFrom.jobTitle" placeholder="请输入" clearable class="inputDiv"></el-input>
            </div>
            <div class="stateDiv">
                <p class="searchText">联系电话</p>
                <el-input v-model="searchFrom.mobile" placeholder="请输入" clearable class="inputDiv"></el-input>
            </div>
            <div class="stateDiv">
                <p class="searchText">出生日期</p>
                <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd" />
            </div>
            <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
            <el-button class="searchBtn" type="warning" @click="addFormData">新增</el-button>
        </div>
        <!--      列表-->
        <div class="table">
            <div class="searchList">
                <TableList :data="tableData" :columnDefs="tableColumns" :total="totalCount" :page="currentPage"
                    @pageChange="handleCurrentChange">
                    <template #action="{ row, index }" class="tableButton">
                        <el-button class="tableBtn" @click="viewOrHandle(row, 'edit')" type="text" size="small">编辑
                        </el-button>
                        <el-button class="tableBtn" @click="viewOrHandle(row, 'view')" type="text" size="small">查看详情
                        </el-button>
                        <el-button class="tableBtn" @click="deleteFun(row)" type="text" size="small">删除</el-button>
                    </template>
                </TableList>
            </div>
        </div>
        <!--    新增/编辑弹框-->
        <div class="dialogDiv">
            <el-dialog :title="eventControl" :visible.sync="dialogFormVisible" :before-close="closeData" center>
                <el-form ref="addForm" :model="addForm" :rules="rules" label-width="120px"
                    :disabled="eventControl === '查看详情'">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="联系人" prop="chineseName" class="formItem">
                                <el-input v-model="addForm.chineseName" clearable placeholder="请输入" maxlength="10"
                                    show-word-limit></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="性别" prop="sex" class="formItem">
                                <el-select v-model="addForm.sex" placeholder="请选择" style="width:100%" clearable>
                                    <el-option v-for="item in sexOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="出生日期" prop="birthday" class="formItem">
                                <el-date-picker v-model="addForm.birthday" type="date" placeholder="选择日期"
                                    style="width:100%" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="婚姻状况" prop="marriageType" class="formItem">
                                <el-select v-model="addForm.marriageType" placeholder="请选择" style="width:100%"
                                    clearable>
                                    <el-option v-for="item in marriageOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="联系电话" prop="mobile" class="formItem">
                                <el-input v-model="addForm.mobile" clearable placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="邮箱" prop="email" class="formItem">
                                <el-input v-model="addForm.email" clearable placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="当前岗位" prop="jobTitle" class="formItem">
                                <el-input v-model="addForm.jobTitle" clearable placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="人才类型" prop="type" class="formItem">
                                <el-select v-model="addForm.type" placeholder="请选择" style="width:100%" clearable>
                                    <el-option v-for="item in talentOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="自有人" prop="hasEmployed" class="formItem">
                                <el-select v-model="addForm.hasEmployed" placeholder="请选择" style="width:100%" clearable>
                                    <el-option v-for="item in isOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="是否为党员" prop="partyMemberFlag" class="formItem">
                                <el-select v-model="addForm.partyMemberFlag" placeholder="请选择" style="width:100%" clearable>
                                    <el-option v-for="item in isOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="参加工作时间" prop="joinWorkDate" class="formItem">
                                <el-date-picker v-model="addForm.joinWorkDate" type="date" placeholder="选择日期"
                                    style="width:100%" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="入职时间" prop="entryDate" class="formItem">
                                <el-date-picker v-model="addForm.entryDate" type="date" placeholder="选择日期"
                                    style="width:100%" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="年假设置" prop="vacationCount" class="formItem">
                                <el-input-number v-model="addForm.vacationCount" :min="0" :max="100" label="描述文字"
                                    style="width:90%;margin-right:5px" :controls="false" disabled></el-input-number>天
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="账号绑定" prop="relUserName" class="formItem">
                                <el-select
                                v-model="addForm.relUserName"
                                placeholder="请选择"
                                style="width:100%"
                                filterable
                                clearable>
                                    <el-option v-for="item in listCanRelTelList" :key="item.chineseName" :label="item.userName"
                                        :value="item.userName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-form-item label="家庭住址" prop="homeAddress" class="formItem">
                            <el-input type="textarea" v-model="addForm.homeAddress" autosize clearable placeholder="请输入"
                                maxlength="50" show-word-limit></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="备注" prop="remark" class="formItem">
                            <el-input type="textarea" v-model="addForm.remark" clearable placeholder="请输入"
                                maxlength="500" show-word-limit></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="简历上传" prop="" class="formItem">
                                <uploadFile @handleFile="handleFile" :attachmentUrlList="addForm.attachmentUrl">
                                </uploadFile>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeData">取 消</el-button>
                    <el-button type="primary" @click="addEventForm()" v-if="eventControl !== '查看详情'">保 存</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { compTalentsInfo } from '@/api/comprehensive'
import { listCanRelTel } from '@/api/basicInfo'
// import { validPassword } from '@/assets/scripts/validate'
import { Message } from 'element-ui'
import TableList from '@/components/TableList'
import uploadFile from '@/components/upload/uploadFile'
import { validPhone, validateEmail } from '../../../utils/validate'
import moment from 'moment'
export default {
    name: 'accountPage',
    components: {
        TableList,
        uploadFile
    },
    data() {
        return {
            loading: false,
            searchFrom: {
                chineseName: '', // 联系人
                sex: '', // 性别
                birthday: '', // 出生年
                marriageType: '', // 婚姻状态
                mobile: '', // 联系电话
                email: '', // 邮箱
                jobTitle: '', // 当前岗位
                type: '', // 人才类型
            },
            time: [],
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            dialogFormVisible: false,
            eventControl: '',
            edit: false,
            passwordForm: {},
            listCanRelTelList: [],
            addForm: {
                chineseName: '', // 联系人
                sex: '', // 性别
                birthday: '', // 出生年
                marriageType: '', // 婚姻状态
                mobile: '', // 联系电话
                email: '', // 邮箱
                jobTitle: '', // 当前岗位
                type: '', // 人才类型
                hasEmployed: '', // 自有人
                attachmentUrl: '', // 简历上传
                remark: '', // 备注
                partyMemberFlag: '', // 是否为党员
                joinWorkDate: '', // 参加工作时间
                entryDate: '', // 入职时间
                vacationCount: '', // 年假设置
                homeAddress: '', // 家庭住址
                relUserName: ''
            },
            rules: {
                chineseName: [{ required: true, message: '请填写', trigger: 'blur' }],
                sex: [{ required: true, message: '请选择', trigger: 'change' }],
                birthday: [{ required: true, message: '请填写', trigger: 'blur' }],
                marriageType: [{ required: true, message: '请选择', trigger: 'change' }],
                mobile: [{ required: true, message: '请填写', trigger: 'blur' }, { validator: validPhone, trigger: 'blur' }],
                email: [{ required: true, message: '请填写', trigger: 'blur' }, { validator: validateEmail, trigger: 'blur' }],
                jobTitle: [{ required: true, message: '请填写', trigger: 'blur' }],
                type: [{ required: true, message: '请选择', trigger: 'change' }],
                hasEmployed: [{ required: true, message: '请选择', trigger: 'change' }],
                partyMemberFlag: [{ required: true, message: '请选择', trigger: 'change' }],
                joinWorkDate: [{ required: true, message: '请选择', trigger: 'change' }],
                entryDate: [{ required: true, message: '请选择', trigger: 'change' }],
                // homeAddress: [{ required: true, message: '请填写', trigger: 'change' }],
                // relUserName: [{ required: true, message: '请选择', trigger: 'change' }],
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e7;
                }
            },
            marriageTypeArr: ['未婚', '已婚', '已婚'],
            tableData: [],
            sexOptions: [
                {
                    label: '男',
                    value: 1
                },
                {
                    label: '女',
                    value: 0
                },
            ],
            isOptions: [
                {
                    label: '是',
                    value: true
                },
                {
                    label: '否',
                    value: false
                },
            ],
            marriageOptions: [
                {
                    label: '未婚',
                    value: 0
                },
                {
                    label: '已婚',
                    value: 1
                },
            ],
            talentOptions: [
                {
                    label: '管理人才',
                    value: '管理人才'
                },
                {
                    label: '专业技术人才',
                    value: '专业技术人才'
                },
                {
                    label: '技能人才',
                    value: '技能人才'
                },
            ],
            tableColumns: [
                {
                    prop: 'chineseName',
                    label: '联系人'
                },
                {
                    prop: 'sex',
                    label: '性别',
                    formatter: (row, column, v) => {
                        return (this.sexOptions.find(v => row.sex === v.value)).label
                    }
                },
                {
                    prop: 'marriageType',
                    label: '婚姻状况',
                    formatter: (row, column, v) => {
                        return (this.marriageTypeArr[row.marriageType])
                    }
                },
                {
                    prop: 'mobile',
                    label: '联系电话'
                },
                {
                    prop: 'birthday',
                    label: '出生年月'
                },
                {
                    prop: 'hasEmployed',
                    label: '是否自有员工',
                    formatter: (row, column, v) => {
                        return row.hasEmployed ? '是' : '否'
                    }
                },
                {
                    prop: 'jobTitle',
                    label: '当前岗位'
                },
                {
                    prop: 'type',
                    label: '人才类型'
                },
                {
                    prop: 'action',
                    label: '操作',
                    width: '200'
                },
            ]
        }
    },
    watch: {
        'addForm.birthday'(val) {
            if (val) {
                if (!moment(val).isBefore(new Date())) {
                    this.addForm.birthday = ''
                    Message.error('不能超过当前日期')
                }
            }
        },
        'addForm.joinWorkDate'(val) {
            let endTime = moment() // 获取当前时间
            let startTime = val // 设置之前时间
            let sum = endTime.diff(startTime, 'months'); // 获取到相差月份
            console.log(sum, 'sumsum');
            if (sum < 12) {
                this.addForm.vacationCount = 0
            }
            if (sum >= 12 && sum < 120) {
                this.addForm.vacationCount = 5
            }
            if (sum >= 120 && sum < 240) {
                this.addForm.vacationCount = 10
            }
            if (sum >= 240) {
                this.addForm.vacationCount = 15
            }
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        handleFile(imgs) {
            let arrFile = imgs.map(v => v.code).join(',')
            this.addForm.attachmentUrl = arrFile
        },
        getData() {
            this.currentPage = 1
            this.queryList()
        },
        async getlistCanRelTel() {
            let res = await listCanRelTel({ 
                chineseName: '',
                pageSize: 999,
                pageNum: 1
            })
            this.listCanRelTelList = res.result
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.queryList()
        },
        async queryList() {
            let res = await compTalentsInfo('query', {
                ...this.searchFrom,
                startTime: this.time?.[0] || '',
                endTime: this.time?.[1] || '',
                pageNum: this.currentPage,
                pageSize: this.pageSize
            })
            if (res.code === 0) {
                this.tableData = res.result.records
                this.totalCount = res.result.total
            }
        },
        addFormData() {
            this.edit = false
            this.dialogFormVisible = true
            this.eventControl = '人才录入'
            this.getlistCanRelTel()
        },
        async viewOrHandle(row, type) {
            console.log(row);
            this.getlistCanRelTel()
            this.edit = true
            this.eventControl = type === 'edit' ? '编辑' : '查看详情'
            this.newOldFormContrast(row)
            this.dialogFormVisible = true
        },
        newOldFormContrast(newForm) {
            Object.keys(this.addForm).forEach(key => {
                this.addForm[key] = newForm[key]
            })
            this.addForm.id = newForm.id
        },
        closeData() {
            this.dialogFormVisible = false
            this.$refs['addForm'].resetFields()
            this.addForm = this.$options.data.call(this).addForm
        },
        addEventForm() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    if (this.edit) {
                        let res = await compTalentsInfo('update', this.addForm)
                        if (res.code === 0) {
                            Message.success('编辑成功！')
                            this.closeData()
                            await this.getData()
                        } else {
                            Message.warning({ message: res.message })
                        }
                    } else {
                        let res = await compTalentsInfo('add', this.addForm)
                        if (res.code === 0) {
                            Message.success('新增成功！')
                            this.closeData()
                            await this.getData()
                        } else {
                            Message.error(res.message)
                        }
                    }
                }
            })
        },
        // 删除用户
        deleteFun(row) {
            this.$confirm('此操作将删除公示, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let params = {
                    'id': row.id
                }
                let res = await compTalentsInfo('delete', params)
                if (res.code === 0) {
                    Message.success('删除成功！')
                }
                await this.getData()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
}

.searchTitleDiv {
    // width: 15rem;
    height: 0.66rem;
    // margin-left: 0.2rem;
    margin-top: 0.05rem;
    /*display: flex;*/
    /*justify-content: space-around;*/

    .stateDiv {
        margin-top: 0.14rem;
        margin-left: .3rem;
        float: left;
    }

    .searchText {
        margin-top: 0.05rem;
        margin-right: 0.13rem;
        font-size: 0.2rem;
        color: #111111;
        float: left;
    }

    .inputDiv {
        width: 2.2rem;
        float: left;
    }

    .searchBtn {
        /*width: 1.20rem;*/
        /*height: 0.36rem;*/
        /*border-radius: 0.06rem;*/
        /*font-size: 0.18rem;*/
        margin-top: 0.14rem;
        margin-left: .3rem;
        /*padding-top: 0.1rem;*/
    }
}

.table {
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;

    .searchList {}

    .paginationBody {
        margin-top: .1rem;
    }
}

.formItem {
    // width: 3.2rem;
}

/deep/ .el-dialog {
    width: 50% !important;
}
</style>
